import IndexTable from "./IndexTable";
import IndexFilters from "./IndexFilters";

export default IndexTable;
export { IndexFilters };
